import React from 'react';
import {
  StoreOutlined,
  CheckCircle,
  DomainOutlined,
  WorkOutlineOutlined,
  BuildOutlined,
  PersonOutlineOutlined,
  EmojiEmotionsOutlined,
} from '@mui/icons-material';
import { Card, Typography } from '@mui/material';

export enum AreasActuation {
  CONSTRUCTOR = 'constructor',
  CANDIDATE = 'candidate',
  SERVICE_PROVIDER = 'service_provider',
  CUSTOMER = 'customer',
  OBRAPRIMA_CUSTOMER = 'obraprima_customer',
  SUPPLIER = 'supplier',
}

interface CardAtuationAreaProps<T extends AreasActuation> {
  name: string;
  text: string;
  type: T;
  isCardSelected?: T;
  onClick: (value: T) => void;
}

export default function CardActuationArea({
  name,
  text,
  isCardSelected,
  onClick,
  type,
}: CardAtuationAreaProps<AreasActuation>) {
  const isSelected = isCardSelected === type;
  const handleIcon = () =>
    ({
      [AreasActuation.SUPPLIER]: (
        <StoreOutlined sx={isSelected ? { color: '#fff' } : {}} />
      ),
      [AreasActuation.CONSTRUCTOR]: (
        <DomainOutlined sx={isSelected ? { color: '#fff' } : {}} />
      ),
      [AreasActuation.CANDIDATE]: (
        <WorkOutlineOutlined sx={isSelected ? { color: '#fff' } : {}} />
      ),
      [AreasActuation.SERVICE_PROVIDER]: (
        <BuildOutlined sx={isSelected ? { color: '#fff' } : {}} />
      ),
      [AreasActuation.CUSTOMER]: (
        <PersonOutlineOutlined sx={isSelected ? { color: '#fff' } : {}} />
      ),
      [AreasActuation.OBRAPRIMA_CUSTOMER]: (
        <EmojiEmotionsOutlined sx={isSelected ? { color: '#fff' } : {}} />
      ),
    }[type]);

  return (
    <>
      <Card
        onClick={() => onClick(type)}
        sx={
          isSelected
            ? {
                width: '100%',
                height: '112px',
                backgroundColor: '#00A8F3',
                borderRadius: '12px',
                p: 1,
                cursor: 'pointer',
              }
            : {
                width: '100%',
                height: '112px',
                backgroundColor: '#FAFAFA',
                borderRadius: '12px',
                p: 1,
                cursor: 'pointer',
              }
        }
        component="div"
      >
        {handleIcon()}

        <CheckCircle
          sx={
            isSelected
              ? {
                  float: 'right',
                  color: '#fff',
                  margin: '4px 4px 0 0',
                }
              : {
                  float: 'right',
                  color: 'rgba(0, 0, 0, 0.05)',
                  margin: '4px 4px 0 0',
                }
          }
        />

        <Typography
          variant="subtitle2"
          sx={isSelected ? { color: '#fff' } : {}}
        >
          {name}
        </Typography>

        <Typography
          variant="body2"
          sx={
            isSelected
              ? {
                  fontSize: '11px',
                  wordBreak: 'break-word',
                  color: 'rgba(255, 255, 255, 0.5)',
                }
              : {
                  fontSize: '11px',
                  wordBreak: 'break-word',
                  color: 'rgba(0, 0, 0, 0.5)',
                }
          }
        >
          {text}
        </Typography>
      </Card>
    </>
  );
}
